.wrapper {
  user-select: none;
  outline: none;
}

.interactiveCell {
  padding: 1px;
}

// Doubled class is an intentional specificity bump
.cellCopied.cellCopied {
  background-color: var(--palettePrimary3);
}

// Doubled class is an intentional specificity bump
.cellFillHighlight.cellFillHighlight {
  background-color: var(--palettePrimary3);
}

.selectionBorder {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.fillHandle {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 6px;
  border-color: transparent var(--palettePrimary0) var(--palettePrimary0) transparent;
  cursor: crosshair;
  z-index: 1;
}
